import { ReactElement } from 'react';

export enum TabsItemType {
    static = 'STATIC',
    simple = 'SIMPLE',
    advanced = 'ADVANCED'
}

export interface TabsItemBaseInterface {
    type: TabsItemType;
    name: string;
    tabAsHeader?: boolean;
    url: string;
    isVisible: boolean;
}

export interface TabsItemStaticInterface extends TabsItemBaseInterface {
    type: TabsItemType.static;
    isLazy?: false;
}

interface TabsItemSimpleInterface extends TabsItemBaseInterface {
    type: TabsItemType.simple;
    component: ReactElement;
    isLazy?: false;
}

interface TabsItemAdvancedInterface extends TabsItemBaseInterface {
    type: TabsItemType.advanced;
    component: React.FC<any>; // eslint-disable-line @typescript-eslint/no-explicit-any
    props: Record<string, any>; // eslint-disable-line @typescript-eslint/no-explicit-any
    isLazy?: boolean;
}

export type TabsItemInterface = TabsItemStaticInterface | TabsItemSimpleInterface | TabsItemAdvancedInterface;
